module.exports = __webpack_public_path__ + "static/media/test7_1.5fd86e0f.png";